namespace $.$$ {

	$mol_style_define( $shm_hitalama_map_widget_float_settings_tabulator, {

		background: {
			color: $mol_theme.card,
		},

	} )

}
